import { useDevice } from '@/hooks/shared/use-device';
import * as React from 'react';
import QRCode from 'react-qr-code';

const textMapping = {
  thisDevice: {
    message: 'Klicka på knappen och verifiera dig med BankID.',
    switchButton: 'BankID på annan enhet? Visa QR-kod istället.',
  },
  notThisDevice: {
    message: 'Öppna BankID-appen på din mobil och scanna QR-koden för att verifiera din identitet.',
    switchButton: 'BankID på denna enhet?',
  },
};

export interface AuthenticationPendingModalProps {
  qrCode: string;
  redirectUrl: string;
}

export default function AuthenticationPendingModal({ qrCode, redirectUrl }: AuthenticationPendingModalProps) {
  const { isMobileOrTablet } = useDevice();
  const [onThisDevice, setOnThisDevice] = React.useState<boolean>(isMobileOrTablet);
  const text = textMapping[onThisDevice ? 'thisDevice' : 'notThisDevice'];

  return (
    <>
      <div className="mb-4 text-center">
        <div className="text-lg font-semibold text-gray-800 dark:text-gray-100 pt-2">
          Inväntar BankID verifiering...
        </div>
      </div>

      {/* Modal content */}
      <div className="text-center">
        <div className="flex flex-col items-center">
          {onThisDevice ? (
            <RedirectButton url={redirectUrl} />
          ) : (
            <QRCode size={200} value={qrCode} className="mt-4 mb-8" />
          )}

          <div className="text-sm">{text.message}</div>
          <div className="text-sm mb-5">
            <button
              onClick={() => setOnThisDevice((prev) => !prev)}
              type="button"
              className="underline text-violet-500 hover:text-violet-800"
            >
              {text.switchButton}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const RedirectButton = ({ url }: { url: string }) => (
  <a
    href={url}
    className="btn-lg mt-4 mb-8 bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
  >
    Öppna BankID-appen
  </a>
);
